import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {
  ConservazioneCaricaDocumentoPecPostaElettronicaCertificataStep2Component
} from './conservazione-carica-documento-pec-posta-elettronica-certificata-step2';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

  $stateProvider
    .state('home.conservazione-carica-documento-pec-posta-elettronica-certificata-step2', {
      url: '/conservazione-carica-pec-posta-elettronica-certificata',
      ncyBreadcrumb: {
        label: 'Carica PEC Posta Elettronica Certificata',
        parent: 'home.conservazione'
      },
      data: {
        authorisationLevel: 1,
        pageTitle: 'Conservazione Carica Documento'
      },
      'views': {
        'homeContent': {
          template: '<conservazione-carica-documento-pec-posta-elettronica-certificata-step2 flex="100"></conservazione-carica-documento-pec-posta-elettronica-certificata-step2>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const ConservazioneCaricaDocumentoPecPostaElettronicaCertificataStep2Module: string = ng
  .module('conservazione-carica-documento-pec-posta-elettronica-certificata-step2', [
    'ui.bootstrap',
    uiRouter,
  ])
  .component('conservazioneCaricaDocumentoPecPostaElettronicaCertificataStep2', ConservazioneCaricaDocumentoPecPostaElettronicaCertificataStep2Component)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/conservazione-carica-documento-pec-posta-elettronica-certificata-step2/conservazione-carica-documento-pec-posta-elettronica-certificata-step2.module.ts